import { stripHtml } from './html';

export const trimHtmlEol = (string: string) => {
  if(!string) {
    return string;
  }
  return string.replace(/(<br \/>)*$/, '');
};

export const cleanHtmlEditorText = (string: string) => {
  if (!stripHtml(string).trim()) {
    return '';
  }

  return string;
};

export const replaceNewlineCharacters = (string: string) => {
  if(!string) {
    return string;
  }

  return string
    .replace(/<br>/g, '<br />')
    .replace(/<p><\/p>/g, '<br />');
};

export const removeLineBreaks = (string: string) => {
  if(!string) {
    return string;
  }
  return string
    .replaceAll(/\n/g, '')
    .replaceAll('<br>', '')
    .replaceAll('<br/>', '')
    .replaceAll('<br />', '')
    .replaceAll('<p>', '')
    .replaceAll('<p/>', '')
    .replaceAll('</p>', '');
};

export const isValidHref = (href: string): boolean => {
  if (!href) return false;
  if (/^#[^\s]+$/.test(href)) return true;
  if (/^https?:\/\/([A-Za-z0-9-]+\.)+[A-Za-z]{2,}(?::\d{2,5})?(?:\/\S*)?$/i.test(href)) return true;
  if (/^([A-Za-z0-9-]+\.)+[A-Za-z]{2,}(?:\/\S*)?$/i.test(href)) return true;
  return false;
};

export const markInvalidAnchors = (html?: string): string => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(`<div id="root">${html}</div>`, 'text/html');
  const root = doc.getElementById('root');
  if (!root) return html;

  root.querySelectorAll('a[href]').forEach((a) => {
    const href = (a.getAttribute('href') || '').trim();
    if (!isValidHref(href)) {
      a.setAttribute('data-invalid-footnote', '1');
    }
  });

  return root.innerHTML;
};